export default __webpack_public_path__ + "static/media/ArdashirCityMap.149f5eb4.jpg";